import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { PROJECTS } from "../data/portfolio";
import { Reveal } from "./Reveal";

export const Projects = () => {
  return (
    <section
      id="projects"
      data-testid="projects-section"
      className="relative border-t border-white/10 py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="flex items-end justify-between mb-16 gap-6">
          <Reveal>
            <p className="label-eyebrow">04 / Selected Work</p>
            <h2 className="mt-4 font-display font-black text-3xl sm:text-4xl lg:text-5xl tracking-tighter leading-tight">
              Things I&apos;ve shipped.
            </h2>
          </Reveal>
          <Reveal delay={150} className="hidden sm:block">
            <p className="text-sm text-white/50 max-w-sm text-right">
              A glimpse — across Gen AI, ML, backend architecture and front-end
              builds.
            </p>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-px bg-white/10 border border-white/10">
          {PROJECTS.map((p, i) => (
            <Reveal
              key={p.id}
              delay={i * 80}
              className={`relative ${p.span}`}
              data-testid={`project-card-${p.id}`}
            >
              <motion.div
                whileHover={{ y: -6 }}
                transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
                className="group relative bg-[#0a0a0a] hover:bg-[#0f0f0f] transition-colors p-8 sm:p-10 h-full"
              >
                {p.image && (
                  <div className="relative w-full h-48 sm:h-56 mb-8 overflow-hidden">
                    <motion.img
                      src={p.image}
                      alt={p.title}
                      initial={{ scale: 1 }}
                      whileHover={{ scale: 1.08 }}
                      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1] }}
                      className="w-full h-full object-cover opacity-60 group-hover:opacity-90 transition-opacity duration-500 grayscale group-hover:grayscale-0"
                    />
                    <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
                  </div>
                )}
                <div className="flex items-start justify-between gap-4">
                  <div>
                    <p className="label-eyebrow">{p.kicker}</p>
                    <h3 className="mt-3 font-display font-bold text-2xl sm:text-3xl tracking-tighter">
                      {p.title}
                    </h3>
                  </div>
                  <motion.div
                    initial={{ x: 0, y: 0, rotate: 0 }}
                    whileHover={{ x: 4, y: -4 }}
                    transition={{ duration: 0.3 }}
                  >
                    <ArrowUpRight
                      size={22}
                      className="text-white/40 group-hover:text-white transition-colors"
                    />
                  </motion.div>
                </div>
                <p className="mt-5 text-sm sm:text-base text-white/65 leading-relaxed">
                  {p.blurb}
                </p>
                <div className="mt-6 flex flex-wrap gap-2">
                  {p.stack.map((t) => (
                    <span
                      key={t}
                      className="text-[10px] font-mono uppercase tracking-[0.18em] text-white/60 border border-white/15 px-2 py-1"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                {/* corner accent that grows on hover */}
                <span className="pointer-events-none absolute bottom-0 left-0 h-px bg-white/60 w-0 group-hover:w-full transition-all duration-500" />
              </motion.div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
